import { useState } from 'react'
import type { ImageItem } from '../api/types'

// A thin horizontal strip that replaces the full gallery section.
// Uses native scroll-snap — no library, no virtualization, no drama.
export function GalleryMarquee({ images }: { images: ImageItem[] }) {
  const [active, setActive] = useState<ImageItem | null>(null)
  if (!images || images.length === 0) return null
  const sorted = [...images].sort((a, b) => (a.order ?? 0) - (b.order ?? 0))

  return (
    <section className="gallery-marquee" aria-label="Galería">
      <div className="gallery-marquee-track">
        {sorted.map((img) => (
          <button
            key={img.id}
            type="button"
            className="gallery-marquee-item"
            onClick={() => setActive(img)}
            aria-label={img.caption || 'Abrir imagen'}
          >
            <img src={img.image} alt={img.caption || ''} loading="lazy" />
          </button>
        ))}
      </div>
      {active && (
        <div
          className="lightbox-backdrop"
          onClick={() => setActive(null)}
          role="dialog"
          aria-modal="true"
        >
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={() => setActive(null)} aria-label="Cerrar">
              ×
            </button>
            <img src={active.image} alt={active.caption || ''} />
            {active.caption && <div className="lightbox-caption">{active.caption}</div>}
          </div>
        </div>
      )}
    </section>
  )
}
